import { Component, Injectable, OnInit, ViewChild , ElementRef, TemplateRef} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BlacklistService } from '../../../../../common/services/Blacklist.service';
import { ExcelService } from 'app/common/services/excel.service';
import * as _ from 'lodash';
import * as XLSX from 'xlsx';

@Component({
    moduleId: module.id,
    selector: "blacklist-config",
    templateUrl: './blacklist.component.html',
    styleUrls: [],
    providers: [BsModalService, BlacklistService, ExcelService]
})

@Injectable()
export class BlacklistComponent implements OnInit {
    public blacklist : any = {};
    public no_image = 'assets/images/contact.png';
    public tab : string = 'blacklist';
    public page_size: number = 10;
    public currentPage: number = 1;
    public message: { class: string, content: string } = null;
    totalItem: any = 0;
    totalPage: any = 0;
    modalRef: any;
    public processingMessage: any = null;
    public file_upload_add: any = null;
    public file_upload_delete: any = null;
    public data_to_upload_add: any;
    public data_to_upload_delete: any;
    public list : any = [];
    public total : number = 0;
    public modelFilter : any = {'action_type': null};
    public model : any = {};
    public postResult: any = null;
    public uploadResult: any = null;
    public modalRef2 : any;
    public id_delete: any;
    public update_blacklist: any = {};
    public limited : number = 10;
    public select2_blacklist_action_type : any = [{id: '0', text: 'Chặn 2 chiều'},{id: '1', text: 'Chặn gọi vào'},{id: '2', text: 'Chặn gọi ra'}];
    dataAddSample: any = [{
        'Email/Số điện thoại': 'test@gmail.com',
        'Hình thức chặn': '0',
        'Loại chặn': 'Chặn quấy rối'
      },
      {
        'Email/Số điện thoại': '0379486666',
        'Hình thức chặn': '1',
        'Loại chặn': 'Chặn ND91'
      },
      {
        'Email/Số điện thoại': 'test2@gmail.com',
        'Hình thức chặn': '2',
        'Loại chặn': 'Chặn ND91'
      },
      {
        'Email/Số điện thoại': '',
      },
      {
        'Email/Số điện thoại': 'Trong đó: 0 - Chặn 2 chiều, 1 - Chặn gọi vào, 2 - Chặn gọi ra',
      }
      ];
    dataDeleteSample: any = [{
        'Email/Số điện thoại': 'test@gmail.com',
      },
      {
        'Email/Số điện thoại': '0379486666',
      },
      {
        'Email/Số điện thoại': 'test2@gmail.com',
      },];

    @ViewChild('template_add_blacklist') template_add_blacklist: ElementRef;
    @ViewChild('template_delete_blacklist') template_delete_blacklist: ElementRef;

    constructor(
        private blacklistService : BlacklistService,
        private toastr: ToastrService,
        private modalService : BsModalService,
        private excelService: ExcelService,
    ) {
        this.blacklist = JSON.parse(localStorage.getItem('Blacklist'));
    }

    ngOnInit() {
        this.loadData();
    }

    loadData(request: any = {}) {
        switch(this.tab) {
            case 'blacklist' :{
                this.loadBlacklist(request);
                break;
            }
            default: break;
        }
    }

    public changedActionTypeFilter(e:any):void {
        this.modelFilter.action_type = e.value;
    }

    public changedBlacklistType(e:any):void {
        this.update_blacklist.action_type = e.value;
    }

    loadBlacklist(request: any = {}, sort: any = {}) {
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        this.blacklistService.list(request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.list = res.data.list;
                this.total = res.data.total;
                
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;

            }
        })
    }

    // openBlacklist(blacklist) {
    //     this.socketService.opentab(blacklist,'blacklist','edit');
    // }

    // openBlacklistOutbound(blacklist_outbound) {
    //     this.socketService.opentab(blacklist_outbound, 'blacklist_outbound', 'edit');
    // }

    openAddBlacklistModal() {
        this.message = null;
        this.postResult = null;
        this.uploadResult = null;
        this.file_upload_add = null;
        this.model.blacklistFormData = "";
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(this.template_add_blacklist, config);
    }

    openDeleteBlacklistModal() {
        this.message = null;
        this.postResult = null;
        this.uploadResult = null;
        this.file_upload_delete = null;
        this.model.blacklistFormData = "";
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(this.template_delete_blacklist,config);
    }

    addBlacklist() {
        let errMessage = "";
        if(!this.model.blacklistFormData){
            errMessage += "Dữ liệu không được bỏ trống";
        }
        if(!errMessage){
            this.blacklistService.create(this.model).subscribe(res => {
                if (res) {
                    let error = res.error;
                    this.message = null;
                    errMessage = "";
                    this.postResult = res.data;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                        this.toastr.error('Thêm mới không thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.toastr.success('Thêm mới thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.model.blacklistFormData = "";
                        this.loadData();
                        // this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
                setTimeout(() => this.message = null, 3000);
            })
        } else {
            this.message = { class: "alert dark alert-danger", content: errMessage };
            setTimeout(() => this.message = null, 3000);
        }
        
      }

      updateBlacklist() {
        this.blacklistService.update(this.update_blacklist).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                    this.toastr.error('Cập nhật không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Cập nhật thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    
                    this.loadData();
                    this.modalRef2.hide();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
            setTimeout(() => this.message = null, 3000);
        })
      }


    search() {
        this.currentPage = 1;
        let objFind = {};
        let check = false;
        if(this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
            objFind = {description : this.modelFilter.keyword.trim()}
            check = true;
        }
        if(this.modelFilter.action_type) {
            objFind['action_type'] = this.modelFilter.action_type;
            check = true;
        }

        if(check) this.loadData(objFind);
        else this.loadData();
    }

    changeTab(tab) {
        this.currentPage = 1;
        this.totalItem = 0;
        this.totalPage = 0;
        this.list = [];
        this.total = 0;
        this.modelFilter = {};
        this.loadData();
    }

    downloadSampleAdd():void {
        this.excelService.exportAsExcelFile(this.dataAddSample, 'sample');
    }

    downloadSampleDelete():void {
        this.excelService.exportAsExcelFile(this.dataDeleteSample, 'sample');
    }

    changeFileAdd(event) {
        this.uploadResult = null;
        let af = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        if (event.target.files.length > 1){
            this.toastr.error('Không chọn được nhiều file', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        }
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (!_.includes(af, file.type)) {
                this.toastr.error('Chỉ hỗ trợ định dạng .xlsx', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            } else {
                const reader: FileReader = new FileReader();
                reader.onload = (e: any) => {
                /* read workbook */
                const bstr: string = e.target.result;
                const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

                /* grab first sheet */
                const wsname: string = wb.SheetNames[0];
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];

                /* save data */
                this.data_to_upload_add = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
                };
                reader.readAsBinaryString(event.target.files[0]);
            }
        } else {
            this.data_to_upload_add = null;
        }
    }

    changeFileDelete(event) {
        let af = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        if (event.target.files.length > 1){
            this.toastr.error('Không chọn được nhiều file', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        }
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (!_.includes(af, file.type)) {
                this.toastr.error('Chỉ hỗ trợ định dạng .xlsx', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            } else {
                const reader: FileReader = new FileReader();
                reader.onload = (e: any) => {
                /* read workbook */
                const bstr: string = e.target.result;
                const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

                /* grab first sheet */
                const wsname: string = wb.SheetNames[0];
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];

                /* save data */
                this.data_to_upload_delete = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
                };
                reader.readAsBinaryString(event.target.files[0]);
            }
        }
    }

    onFormAddSubmit() {
        if(!this.data_to_upload_add){
            this.toastr.error('Chưa có dữ liệu', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        } else {
            this.uploadResult = null;
            this.processingMessage = 'Đang xử lý dữ liệu, vui lòng đợi';
            this.blacklistService.uploadAdd(this.data_to_upload_add).subscribe(res => {
                if (res) {
                    this.processingMessage = null;
                    this.message = null;
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                        this.toastr.error('Thêm mới không thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.uploadResult = res.data;
                        this.toastr.success('Thêm mới thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.message = null;
                        this.loadData();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
                setTimeout(() => this.message = null, 3000);
            })
        }
        
    }

    onFormDeleteSubmit() {
        if(!this.data_to_upload_delete){
            this.toastr.error('Chưa có dữ liệu', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
        } else {
            this.processingMessage = 'Đang xử lý dữ liệu, vui lòng đợi';
            this.uploadResult = null;
            this.blacklistService.uploadDelete(this.data_to_upload_delete).subscribe(res => {
                if (res) {
                    this.processingMessage = null;
                    this.message = null;
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Xóa không thành công" };
                        this.toastr.error('Xóa không thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.uploadResult = res.data;
                        this.toastr.success('Xóa thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        
                        this.loadData();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
                setTimeout(() => this.message = null, 3000);
            })
        }
        
    }


    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadData();
            }
        }
        else {
            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadData();
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

    openUpdateBlacklist(template: TemplateRef<any>, blacklist){
        this.update_blacklist.id = blacklist._id;
        this.update_blacklist.data = blacklist.data;
        this.update_blacklist.action_type = blacklist.action_type;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef2 = this.modalService.show(template,config);
    }

    openConfirmDelete(template: TemplateRef<any>, id) {
        this.id_delete = id;
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa không?");
        if(y){
            this.submitDelete();
        }
    }

    submitDelete() {
        this.blacklistService.delete(this.id_delete).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.toastr.error('Xóa không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Xóa thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.loadData();
                    // this.modalRef2.hide();
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        });
    }

    deleteBlacklist() {
        let errMessage = "";
        if(!this.model.blacklistFormData){
            errMessage += "Dữ liệu không được bỏ trống";
        }
        if(!errMessage){
            this.blacklistService.deleteMulti(this.model).subscribe(res => {
                if (res) {
                    let error = res.error;
                    this.message = null;
                    errMessage = "";
                    this.postResult = res.data;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Xóa không thành công" };
                        this.toastr.error('Xóa không thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.toastr.success('Xóa thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.model.blacklistFormData = "";
                        this.loadData();
                        // this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
                setTimeout(() => this.message = null, 3000);
            })
        } else {
            this.message = { class: "alert dark alert-danger", content: errMessage };
            setTimeout(() => this.message = null, 3000);
        }
        
      }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/blacklist/blacklist.component.ts